<script setup lang="ts">
/** /germany — Donoor pour les associations du pays (contenu : components/pays/PagePays.vue). */
import PagePays from "~/components/pays/PagePays.vue";
</script>

<template>
  <PagePays pays="de" />
</template>
